<template>
  <div class="popup-main">
    <el-dialog
      :title="detailId ? '编辑职位分类' : '新增职位分类'"
      width="800px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <div v-if="loaded">
          <e-form
            ref="refForm"
            :config="formConfig"
            :column="formColumn"
            :rules="formRules"
            :data.sync="selfData"
          />
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    parentId: {
      type: [Number, String],
      required: true
    },
    parentName: {
      type: String,
      required: true
    },
    detailId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      loaded: false,
      selfShow: false,
      selfData: {
        parent_id: '',
        parent_name: '',
        id: '',
        name: '',
        remark: '',
        status: true
      },
      formConfig: {
        inline: false,
        width: '100%'
      },
      formColumn: [
        {
          type: 'text',
          title: '上级分类',
          field: 'parent_name',
          placeholder: ' ',
          disabled: true
        },
        {
          type: 'text',
          title: '职位分类名称',
          field: 'name',
          required: true
        },
        {
          type: 'text',
          title: '职位分类描述',
          field: 'remark'
        },
        {
          type: 'switch',
          title: '状态',
          field: 'status'
        }
      ],
      formRules: {
        name: [{ required: true, message: '请输入职位分类名称' }]
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.detailId) {
      this.getDetailData()
    } else {
      this.initSelfData()
    }
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.loaded = false
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/gangWeiFenLei2/detail',
        params: {
          id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.data)
          this.selfData = result
        }
      })
      this.loaded = true
    },
    // 初始化数据
    initSelfData() {
      this.loaded = false
      this.selfData.parent_id = this.parentId
      this.selfData.parent_name = this.parentName
      this.loaded = true
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$api({
            method: 'post',
            url: '/admin/gcvip/gangWeiFenLei2/saveOrUpdate',
            data: {
              form_data: this.selfData
            }
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.popupCancel()
                this.$emit('success')
                this.$message.success('保存成功')
              }
            })
            .catch((error) => {
              this.$message.error(error)
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
